import { NgModule } from "@angular/core";
import { CommonModule} from '@angular/common';

import {QuestionnaireTitleComponent} from './questionnaire-title/questionnaire-title.component';
import {QuestionnaireHeadPhotoComponent} from './questionnaire-head-photo/questionnaire-head-photo.component';
import {QuestionnaireGradeComponent} from './questionnaire-grade/questionnaire-grade.component';
import {QuestionnaireTagComponent} from './questionnaire-tag/questionnaire-tag.component';
import {QuestionnaireTextareaComponent} from './questionnaire-textarea/questionnaire-textarea.component';

@NgModule({
	  imports:[CommonModule],
    declarations:[
      QuestionnaireTitleComponent,
      QuestionnaireHeadPhotoComponent,
      QuestionnaireGradeComponent,
      QuestionnaireTagComponent,
      QuestionnaireTextareaComponent
    ],
    exports:[
      QuestionnaireTitleComponent,
      QuestionnaireHeadPhotoComponent,
      QuestionnaireGradeComponent,
      QuestionnaireTagComponent,
      QuestionnaireTextareaComponent
    ]
})

export class AppQuestionnaireModule{

}




// WEBPACK FOOTER //
// ./src/app/app-questionnaire/app-questionnaire.module.ts